export default {
  props: {
    title: String,
    icon: String,
    email: String,
  },
};
